import React, {Component, Fragment} from 'react';
import Grid from "@material-ui/core/Grid";
import {DateRangeOutlined, PersonOutlined, SearchOutlined, GroupOutlined, CardTravel} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import {FieldsJs} from '../../../../settings/General/General';
import Fab from "@material-ui/core/Fab";
import PropTypes from "prop-types";

import MDDatePicker from "../../../Include/MDDatePicker/MDDatePicker";
import {DateFormat} from "../../../../settings/DateFormat/DateFormat";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {CatService} from "../../../../services/_Cat/CatService/CatService";


class FiltrosFacturas extends Component {
	state = {};
	
	constructor() {
		super();
		this.state = {
			folio: '',
			numero_cotizacion: '',
			numero_pedido: '',
			cliente: '',
			fecha_alta_inicio: null,
			fecha_alta_fin: null,
			fecha_entrega_inicio: null,
			fecha_entrega_fin: null,
			status_pago: 'all',
			status_proceso: 'all',
			status_tipo_pedido: 'all',
			id_usuario_disenador: '',
			id_cat_grupo: '',
			ordenar_fecha_alta: false,
			ordenar_fecha_entrega: false,
			producto: '',
			id_cat_envio_estatus: '',
			filtro_cat_usuario_disenador: [],
			filtro_cat_grupo: [],
			filtro_cat_envio_estatus: [],
		};
		
		this.ListaUsuarioDisenador();
		this.ListaGrupo();
		this.ListaEnvioEstatus();
		
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
		setTimeout(() => this.HandleFiltro());
	};
	
	HandleFiltro = () => {
		let filtro = {};
		
		filtro.folio = this.state.folio || undefined;
		filtro.numero_cotizacion = this.state.numero_cotizacion || undefined;
		filtro.numero_pedido = this.state.numero_pedido || undefined;
		filtro.cliente = this.state.cliente || undefined;
		filtro.fecha_alta_inicio = this.state.fecha_alta_inicio && this.state.fecha_alta_fin ? this.state.fecha_alta_inicio : undefined;
		filtro.fecha_alta_fin = this.state.fecha_alta_inicio && this.state.fecha_alta_fin ? this.state.fecha_alta_fin : undefined;
		filtro.fecha_entrega_inicio = this.state.fecha_entrega_inicio && this.state.fecha_entrega_fin ? this.state.fecha_entrega_inicio : undefined;
		filtro.fecha_entrega_fin = this.state.fecha_entrega_inicio && this.state.fecha_entrega_fin ? this.state.fecha_entrega_fin : undefined;
		filtro.status_pago = this.state.status_pago || undefined;
		filtro.status_proceso = this.state.status_proceso || undefined;
		filtro.status_tipo_pedido = this.state.status_tipo_pedido || undefined;
		filtro.id_usuario_disenador = this.state.id_usuario_disenador || undefined;
		filtro.id_cat_grupo = this.state.id_cat_grupo || undefined;
		filtro.ordenar_fecha_alta = this.state.ordenar_fecha_alta ? 1 : undefined;
		filtro.ordenar_fecha_entrega = this.state.ordenar_fecha_entrega ? 1 : undefined;
		filtro.producto = this.state.producto || undefined;
		filtro.id_cat_envio_estatus = this.state.id_cat_envio_estatus || undefined;
		
		this.props.HandleFiltro(filtro);
	};
	
	AplicarFiltro = () => {
		this.props.AplicarFiltros();
	};
	
	ListaUsuarioDisenador = () => {
		CatService.ListUsuarioDisenador().then((cat) => {
			this.setState({
				filtro_cat_usuario_disenador: cat.data
			})
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	ListaEnvioEstatus = () => {
		CatService.ListEnvioEstatus().then((cat) => {
			this.setState({
				filtro_cat_envio_estatus: cat.data
			})
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	ListaGrupo = () => {
		CatService.ListGrupo().then((cat) => {
			this.setState({
				filtro_cat_grupo: cat.data
			})
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	render() {
		return (
			<Fragment>
				
				<Grid container spacing={2} alignContent={"flex-end"} alignItems={"flex-end"}>
					<Grid item className={'text-left'} xs={6} sm={6} md={2} lg={2} xl={2}>
						<TextField
							type={'text'}
							fullWidth
							name="folio"
							onChange={this.handleChange}
							label="Folio"
							autoComplete={'off'}
							value={this.state.folio}
						/>
					</Grid>
					
					<Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
						<MDDatePicker
							type={'range'}
							component={(
								<TextField
									fullWidth
									label="Fecha de alta"
									value={(this.state.fecha_alta_inicio && this.state.fecha_alta_fin) ? (DateFormat.FormatText(this.state.fecha_alta_inicio) + " al " + DateFormat.FormatText(this.state.fecha_alta_fin)) : ''}
									readOnly
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton aria-label="Fecha de alta">
													<DateRangeOutlined/>
												</IconButton>
											</InputAdornment>
										)
									}}
								/>
							)}
							startDate={this.state.fecha_alta_inicio}
							endDate={this.state.fecha_alta_fin}
							onChange={(range) => {
								this.setState({
									fecha_alta_inicio: range.startDate,
									fecha_alta_fin: range.endDate,
								});
								setTimeout(() => this.HandleFiltro());
							}}
						/>
					</Grid>
					
					<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
								<Fab variant="extended" size="small" color="default" aria-label="Add"
								     onClick={this.AplicarFiltro}>
									<SearchOutlined className={'margin-5-R px-14'}/> Buscar
								</Fab>
					</Grid>
				
				</Grid>
			
			</Fragment>
		);
	}
}

FiltrosFacturas.propTypes = {
	HandleFiltro: PropTypes.func.isRequired,
	AplicarFiltros: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	tipo_vista: PropTypes.string.isRequired,
};

export default FiltrosFacturas;
